module.exports = __webpack_public_path__ + "static/catalog-en-870f8683ec90010084480245acd30acb.pdf";